// Los cuatro tests de la Academia, en un sitio.
//
// COPIA DECLARADA de `TESTS` en `backend/app/domain/tests_alpha.py`: las claves y el
// número de XP tienen que decir lo mismo en los dos idiomas, y `tools/prueba_tests.py` se
// cae si dejan de decirlo. Es la misma situación que `etapa.mjs` y se resuelve igual.
//
// Lo que hay aquí y no allí es lo que solo sirve para pintar: el titular de la portada,
// cuánto se tarda y el aviso de qué se guarda. Lo que hay allí y no aquí es lo que decide:
// qué se calcula y cuánto XP se abona.
// Las cuatro importaciones llevan `.js` a proposito: asi este fichero se puede leer tal
// cual con `node`, que es como `tools/prueba_tests.py` comprueba que el navegador y el
// servidor dicen lo mismo. Webpack resuelve igual con extension que sin ella.
import { PREGUNTAS_RUTA } from "./ruta.js";
import { PREGUNTAS_AFINIDAD } from "./afinidad.js";
import { PREGUNTAS_APRENDES } from "./aprendes.js";
import { PREGUNTAS_INTERES } from "./interes.js";
import { PREGUNTAS_TECNICAS } from "./tecnicas.js";

// Lo que da un test largo, y el valor por defecto. Desde el 4 de septiembre NO todos dan lo
// mismo: el de intereses son cinco pantallas de marcar casillas y da 20. Un numero que vale
// igual hagas lo que hagas deja de medir nada. El de cada ficha manda, y `tools/prueba_tests.py`
// exige que este fichero y `domain/tests_alpha.py` digan lo mismo test por test.
//
// Y EL 18 DE OCTUBRE DE 2026 LOS DOS DE ARRIBA SE CRUZARON: la ruta se quedo en cinco
// preguntas y tecnicas subio a dieciocho. El motivo de bajar la ruta a 20 aun siendo la
// puerta de entrada esta en `domain/tests_alpha.py`, y se resume en que el alumno no sabe
// lo que paga un test hasta que lo termina.
export const XP_POR_TEST = 60;

export const TESTS = {
  ruta: {
    clave: "ruta",
    // Entre cuatro y seis preguntas segun por donde vayas: el peldaño de los cortos.
    xp: 20,
    nombre: "Ruta recomendada",
    subtitulo: "Por dónde empezar",
    donde: "academia",
    titular: "¿Por dónde empiezo?",
    entradilla:
      "Cinco preguntas, y no las mismas para todos: las que no van contigo no se preguntan. Al final, el curso por el que empezar y por qué encaja, condición por condición. No es un veredicto: es una recomendación, y se puede rehacer.",
    minutos: "≈2",
    preguntas: PREGUNTAS_RUTA,
  },
  afinidad: {
    clave: "afinidad",
    // Diez preguntas: peldaño del medio de la escala (60 / 40 / 20). Eran ocho hasta el 18
    // de octubre de 2026, cuando llegaron dos del test de ruta que preguntaban por el trato.
    xp: 40,
    nombre: "Afinidad con tu mentor",
    subtitulo: "Quién te acompaña",
    donde: "academia",
    titular: "¿Quién te acompaña?",
    entradilla:
      "Diez preguntas sobre cómo te gusta que te hablen: cuando aciertas, cuando fallas y cuando te atascas. Al final, cuál de los cinco mentores encaja mejor contigo. Se cambia cuando quieras.",
    minutos: "≈3",
    preguntas: PREGUNTAS_AFINIDAD,
  },
  aprendes: {
    clave: "aprendes",
    // Nueve preguntas: peldaño del medio.
    xp: 40,
    // SE LLAMABA «Cómo aprendes» Y LO CAMBIÓ GABRI EL 14 DE SEPTIEMBRE DE 2026: «el título del
    // test debería ser "personaliza la plataforma" o "adapta la plataforma a tus necesidades"».
    //
    // Y NO ES UN CAMBIO DE ROPA. «Cómo aprendes» promete un diagnóstico —suena a que al final
    // alguien te va a decir cómo eres— y lo que hay al final son **siete ajustes que se aplican
    // con un botón**. El nombre decía una cosa y el test hacía otra, y de las dos la buena es la
    // que hace: nadie contesta doce preguntas para que le describan, y sí para que la
    // plataforma deje de molestarle.
    nombre: "Personaliza la plataforma",
    subtitulo: "Personaliza la plataforma",
    donde: "academia",
    titular: "Adapta la plataforma a tus necesidades",
    entradilla:
      "Nueve preguntas de dos opciones. No hay respuestas mejores: hay la tuya. Lo que elijas queda escrito, se aplica a cómo te habla la Academia y se cambia desde Ajustes el día que deje de ser verdad.",
    minutos: "≈2",
    preguntas: PREGUNTAS_APRENDES,
  },
  interes: {
    clave: "interes",
    // Veinte y no sesenta: cinco pantallas de casillas contra las veintidos preguntas de la
    // ruta. El motivo entero, en `domain/tests_alpha.py`.
    xp: 20,
    nombre: "Qué te interesa",
    subtitulo: "De dónde salen los ejemplos",
    donde: "academia",
    // `varias`: las preguntas se marcan, no se aciertan. Es el único de los cinco.
    tipo: "varias",
    titular: "¿De qué te gusta que vayan los ejemplos?",
    entradilla:
      "Cinco pantallas para marcar lo que te suene. No hay respuestas correctas ni límite: marca todo lo que te interese de verdad. Las cuatro primeras sirven para que los ejemplos del mentor caigan cerca de ti; en la última marcas cursos, que saldrán primero en el catálogo. Se cambia cuando quieras.",
    minutos: "≈2",
    preguntas: PREGUNTAS_INTERES,
  },
  tecnicas: {
    clave: "tecnicas",
    // Dieciocho preguntas: el peldaño de arriba desde el 18 de octubre de 2026. Eran doce
    // y pagaba 40; las seis que entraron son de repaso, apuntes y constancia -el terreno de
    // este test-, y con ellas pasó a ser el largo.
    xp: 60,
    nombre: "Técnicas de estudio",
    subtitulo: "Qué usas y qué te falta",
    donde: "lab",
    titular: "¿Cómo estudias ahora?",
    entradilla:
      "Dieciocho preguntas sobre lo que haces de verdad cuando te sientas a estudiar. Al final, las técnicas que no estás usando y dónde aprenderlas. Estudiar no es una capacidad que se tiene: es un puñado de técnicas que se aprenden.",
    minutos: "≈4",
    preguntas: PREGUNTAS_TECNICAS,
  },
};

export const CLAVES_TEST = Object.keys(TESTS);

export const testPorClave = (clave) => TESTS[clave] || null;

/**
 * Lo que paga un test: el suyo si lo tiene, y si no el de siempre.
 *
 * VA DETRÁS DE `TESTS` Y NO DELANTE. Una flecha guardada en un `const` no se iza como una
 * función, así que escrita arriba se lee antes de existir: `no-use-before-define`, y eso dejaba
 * TODO el frontend en rojo —el portero de eslint no distingue de quién es el fichero—. Aquí no
 * puede pasar: lo que usa ya está escrito encima.
 */
export const xpDe = (clave) => {
  const t = TESTS[clave];
  return t && typeof t.xp === "number" ? t.xp : XP_POR_TEST;
};
